import type { ComponentProps } from 'react'
import { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import clsx from 'clsx'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import TripPlannerHomeLogoLink from 'tripPlanner/components/Header/TripPlannerHomeLogoLink'
import TripPlannerNavigation from './TripPlannerNavigation'

const HeaderLogoWrapper = styled.div`
  display: flex;
  align-items: center;
`

const NavigationFrame = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-block-size: 0;

  &.mobile {
    padding-block: ${rem(16)} calc(${rem(12)} + env(safe-area-inset-bottom));
  }
`

interface Props extends Omit<ComponentProps<typeof TripPlannerNavigation>, 'onNavigate'> {
  variant?: 'default' | 'mobile'
  isOpen: boolean
  onClose: () => void
  onNavigate: () => void
  onAfterClose: () => void
}

function TripPlannerDrawer({
  variant = 'default',
  isOpen,
  onClose,
  onNavigate,
  onAfterClose,
  ...navigationProps
}: Props) {
  const headerTitle = useMemo(() => (
    <HeaderLogoWrapper>
      <TripPlannerHomeLogoLink onClick={onNavigate} />
    </HeaderLogoWrapper>
  ), [onNavigate])

  return (
    <ModalBase
      mode="menu"
      isOpen={isOpen}
      onClose={onClose}
      onAfterClose={onAfterClose}
    >
      <ModalHeader title={headerTitle} onCloseButtonClick={onClose} />
      <ModalBody>
        <NavigationFrame className={clsx({ mobile: variant === 'mobile' })}>
          <TripPlannerNavigation
            {...navigationProps}
            onNavigate={onNavigate}
          />
        </NavigationFrame>
      </ModalBody>
    </ModalBase>
  )
}

export default TripPlannerDrawer
